import { Component, Input, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { PaginationModel } from 'src/app/Models/pagination-model';

@Component({
  selector: 'ze-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})

export class PaginationComponent implements OnInit {
  public currentPageNo = 1;
  public size = 1;
  public pagenos;
  @Input() pageDetails: PaginationModel;
  @Output("gotoPage") gotoPage = new EventEmitter();

  constructor() {
  }
  ngOnChanges(changes: SimpleChanges) {
    this.pageDetails = changes.pageDetails.currentValue;
    this.initPageDetails();
  }
  ngOnInit() {
    this.initPageDetails();
  }
  initPageDetails() {
    if (!this.pageDetails)
      return;
    this.currentPageNo = this.pageDetails.currentPage;
    this.size = this.pageDetails.size;
    if (this.size <= 11) {
      this.pagenos = [...Array(this.size).keys()]
    }
    else {
      let sliceFactorNo = this.currentPageNo < 4 ?
        [...Array(5).keys()] :
        [...Array(this.currentPageNo <= this.size - 3 ?
          this.currentPageNo + 2 :
          this.size
        ).keys()].slice(-5);
      let lastsection = [...Array(this.size).keys()].slice(-2);
      if (this.currentPageNo > 3)
        this.pagenos = [...[0, 1, '.']];
      if (this.pagenos && this.currentPageNo > 3 && this.currentPageNo < this.size - 2)
        this.pagenos = [...this.pagenos, ...sliceFactorNo, '.', ...lastsection];
      else if (this.pagenos && this.currentPageNo > this.size - 5)
        this.pagenos = [...this.pagenos, ...sliceFactorNo];
      else
        this.pagenos = [...sliceFactorNo, '.', ...lastsection];
    }
  }
  emitGotoPage(event) {
    this.gotoPage.emit(event);
  }
}

